import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './style.scss'
import registrationApi from 'api/registrationApi'
import countryApi from 'api/countryApi'
import toolApi from 'api/toolApi'
import { setAppSpinning } from 'app/appSlice'
import { setSelectedDigitalCertificate } from 'app/toolSlice'
import customProtocolCheck from 'custom-protocol-check'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import ModalChooseSignMethod from 'features/Invoice/screens/GuestSignInvoiceReport/components/ModalChooseSignMethod'
import ModalConnectConfig from 'features/System/components/Modals/ModalConnectConfig'
import PrivateBaseLayout from 'general/components/eInvoiceComponents/BaseLayout/PrivateBaseLayout'
import {
  COMPANY_TYPE_FORM,
  MAX_WAIT_SIGN_INVOICE,
  REGISTRATION_TYPE,
} from 'general/constants/AppConstants'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import ToastHelper from 'general/helpers/ToastHelper'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  padNumber,
  setTaxCode,
  viewPopupSettingTool,
} from 'general/utils/Utils'
import { useRef } from 'react'
import DatePicker from 'react-datepicker'
import { useDispatch, useSelector } from 'react-redux'
import ModalSignatureInfo from './components/SignatureInfoModal'
import { useQuery } from '@tanstack/react-query'
import axiosClient from 'api/axiosClient'
import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Empty, Modal, Tooltip } from 'antd'
import ModalWarning from 'general/components/Modal/ModalWarning'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import { InputField } from './components/InputFields'
import { ListCertificates } from './components/ListCertificates'
import ReusableTable from './components/ReusableTable'
import {
  defaultEInvoiceConnectorValue,
  defaultServiceProviderValue,
  DependentUnitsInvoiceAccess,
  EInvoiceConnectorColumns,
  EInvoiceSuspendRequest,
  serviceProviderColumns,
} from './components/Common/Columns'
import {
  thunkGetCompanyProfile,
  thunkGetTaxAuthority2025,
} from 'features/System/systemSlice'
import { SelectCustom } from 'features/TaxDeductionDocuments/styled'
import { useTranslation } from 'react-i18next'
dayjs.locale('en')

const cerTypeOptions = [
  { label: 'Thêm mới', value: 1 },
  { label: 'Gia hạn', value: 2 },
  { label: 'Ngừng sử dụng', value: 3 },
]

const registrationType = [
  {
    id: 'registration-new',
    value: 1,
    label: 'Đăng ký mới',
  },
  {
    id: 'registration-change',
    value: 2,
    label: 'Thay đổi thông tin',
  },
  {
    id: 'registration-change-of-other-system',
    value: 3,
    label: 'Cập nhật thông tin tờ khai từ hệ thống Vietinvoice',
  },
]

const MAX_WAIT_SIGN_REGISTRATION = 30000

const registrationDefault = {
  type: 1,
  no: 'ĐKTĐ00001',
  // date: '2023-05-31 16:24:18',
  // companyName: 'CÔNG TY CỔ PHẦN ĐẦU TƯ INDO',
  // companyTaxCode: '0312303803-999',
  // taxAuthorityName: 'Chi Cục thuế Quận Tây Hồ',
  // companyContactPerson: 'Nguyễn Thị Thoan',
  // companyAddress: 'Số 32/337, Phố Cầu Giấy, Phường Dịch Vọng, Quận Cầu Giấy, Thành Phố Hà Nội',
  // companyEmail: 'ketoanicorp@gmail.com',
  // companyPhoneNumber: '0989102859',

  formWithTaxAuthCode: 1,
  formWithoutTaxAuthCode: 0,
  formPosTaxAuthCode: 0,
  usingPosInvoiceWithoutTaxCode: 0,

  transTacDiaBanKK: 0,
  transTacUBND: 0,

  transNoTacDirect: 0,
  transNoTacIndirect: 0,
  transServiceFromOtherCountry: 0,
  transForeignOrganization: 0,

  transferMethodDetail: 1,
  transferMethodSummary: 0,
  transferMethodCDLTHDThu: 0,
  transferMethodCTTCTGDich: 0,

  usingVat: 1,
  usingVatWithTaxFeeReceipt: 0,
  usingSale: 0,
  usingSaleWithTaxFeeReceipt: 0,
  usingCommercialInvoice: 0,
  usingSalePublicProperty: 0,
  usingSaleNationalReserve: 0,
  usingOther: 0,
  usingBill: 0,
  usingForeignSupplierInvoice: 0,

  companyCount: 1,

  nationalityCode: 'VN',
  nationalityName: 'Việt Nam',

  // locationName: 'Hà Nội',
}

var initialRegistration = registrationDefault

// Hàm helper để chuyển đổi giá trị boolean thành 0/1
const booleanToNumber = (value) => (value ? 1 : 0)

const taxpayerInfoTooltip = (
  <div
    style={{
      color: '#212529',
      lineHeight: 1.5,
    }}
  >
    <div style={{ fontWeight: 700, marginBottom: 8 }}>
      Khai báo Tên, Địa chỉ của hộ kinh doanh theo hướng dẫn của cơ quan thuế
    </div>
    <div>
      Tên, địa chỉ của hộ kinh doanh: Là thông tin tên, địa chỉ trụ sở ghi trên
      giấy chứng nhận đăng ký hộ kinh doanh hoặc thông tin địa chỉ đã được cơ
      quan thuế rà soát cập nhật tương ứng theo địa bàn hành chính 02 cấp.
    </div>
    <div>
      Vui lòng kiểm tra lại thông tin tại <strong>Hồ sơ hóa đơn điện tử</strong>{' '}
      để cập nhật theo đúng hướng dẫn của cơ quan thuế.
    </div>
  </div>
)

function CreateRegistration() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { registrationId } = useParams()
  const { pathname } = useLocation()

  const { selectedDigitalCertificate } = useSelector((state) => state.tool)
  const { company, taxAuthorities2025 } = useSelector((state) => state.system)
  const isHouseholdCompany =
    company?.companyType === COMPANY_TYPE_FORM.HOUSEHOLD
  const system = useSelector((state) => state.system)
  console.log('state.system:', system)
  const [registration, setRegistration] = useState()

  const { data: countryList = [] } = useQuery({
    queryKey: ['countryList'],
    queryFn: async () => {
      const res = await countryApi.getAll()
      return Array.isArray(res?.data) ? res.data : []
    },
    staleTime: Infinity,
  })

  useEffect(() => {
    setRegistration(undefined)
    initialRegistration = registrationDefault
  }, [])

  useEffect(() => {
    if (registration?.provinceCode) {
      dispatch(
        thunkGetTaxAuthority2025({
          provinceCityCode: registration?.provinceCode,
        }),
      )
    } else if (!registrationId && company?.provinceCode) {
      dispatch(
        thunkGetTaxAuthority2025({
          provinceCityCode: company?.provinceCode,
        }),
      )
    }
  }, [dispatch, registration?.provinceCode, company])

  const systemType = useSelector((s) => s.auth?.activeInvoice)

  const [registrationExisted, setRegistrationExisted] = useState()

  const [selectedCertificates, setSelectedCertificates] = useState([])
  const [showModal, setShowModal] = useState({
    connectConfig: false,
    signatureInfo: false,
    chooseSignMethod: false,
    confirm: false,
    warning: { visible: false, message: '' },
  })
  const [isInvoiceTypeGuideOpen, setIsInvoiceTypeGuideOpen] = useState(false)
  const [isDataTransferGuideOpen, setIsDataTransferGuideOpen] = useState(false)
  const [isTransferMethodGuideOpen, setIsTransferMethodGuideOpen] =
    useState(false)
  const [isInvoiceTypeListGuideOpen, setIsInvoiceTypeListGuideOpen] =
    useState(false)
  const [isServiceProviderGuideOpen, setIsServiceProviderGuideOpen] =
    useState(false)
  const [isEInvoiceConnectorGuideOpen, setIsEInvoiceConnectorGuideOpen] =
    useState(false)
  const [isDependentUnitsGuideOpen, setIsDependentUnitsGuideOpen] =
    useState(false)
  const [isEInvoiceSuspendGuideOpen, setIsEInvoiceSuspendGuideOpen] =
    useState(false)
  const [inforSaveAndSign, setInforSaveAndSign] = useState({ disabled: false })
  const screenAction =
    window.location.pathname?.split('/')?.[2] == 'tem-ve'
      ? useMemo(() => pathname?.split('/')?.at(4), [pathname])
      : useMemo(() => pathname?.split('/')?.at(3), [pathname])
  const protoType = useRef(null)
  useLayoutEffect(() => {
    return () => dispatch(setSelectedDigitalCertificate(undefined))
  }, [])

  const userFunction = useSelector((state) => state?.function?.userFunctions)
  const listFunction = useSelector((state) => state?.function?.listFunctions)

  const [themFunction, suaFunction] = useMemo(() => {
    return Utils.checkFunction(
      [
        {
          listFunctionCode: 'TOKHAI_ADD',
        },
        {
          listFunctionCode: 'TOKHAI_EDIT',
        },
      ],
      userFunction,
      listFunction,
    )
  }, [userFunction, listFunction])

  const codeTemplate = useMemo(() => {
    let x = 'x'

    if (registration?.usingOther) x = 5
    if (registration?.usingSale) x = 2
    if (registration?.usingVat) x = 1

    return `M${x}-${dayjs().year() % 100}-${registration?.companyIssuedTaxAuthorityCode || '...'}-${padNumber(registration?.companyCount || 1, 11)}`
  }, [registration])

  const gotDetailRegistration = useRef(false)
  useEffect(() => {
    if (userFunction?.length && listFunction?.length) {
      if (registrationId) {
        if (!gotDetailRegistration.current)
          (async function () {
            if (!suaFunction) {
              ToastHelper.showError('Bạn không có quyền sửa tờ khai')
              gotDetailRegistration.current = true
              return
            }

            dispatch(setAppSpinning(true))
            var res
            try {
              res = await registrationApi.getDetail(registrationId)
            } catch (e) {
              console.log(e)
            } finally {
              dispatch(setAppSpinning(false))
              gotDetailRegistration.current = true
            }
            if (res?.registration) {
              // Tổ chức cung cấp dịch vụ
              res.registration.service_provider =
                res.registration.unitRelations?.SERVICE_PROVIDER ||
                defaultServiceProviderValue
              // Thông tin đơn vị truyền nhận
              res.registration.e_invoice_connector =
                res.registration.unitRelations?.E_INVOICE_CONNECTOR ||
                defaultEInvoiceConnectorValue
              // Thông tin đơn vị hạch toán
              res.registration.dependent_units_invoice_access =
                res.registration.unitRelations
                  ?.DEPENDENT_UNITS_INVOICE_ACCESS || []
              // Thông tin yêu cầu tạm dừng hóa đơn
              res.registration.e_invoice_suspend_request =
                res.registration.unitRelations?.E_INVOICE_SUSPEND_REQUEST || []
              setRegistration(res.registration)
              setRegistrationExisted(res.registration)
            }
          })()
      } else {
        if (!Utils.isObjectEmpty(company))
          (async function () {
            if (!themFunction) {
              ToastHelper.showError('Bạn không có quyền thêm tờ khai')
              gotDetailRegistration.current = true
              return
            }

            dispatch(setAppSpinning(true))
            try {
              let res = await registrationApi.getPrototype()

              let {
                type,
                no,
                formPosTaxAuthCode,
                formWithTaxAuthCode,
                formWithoutTaxAuthCode,
                usingPosInvoiceWithoutTaxCode,
                transNoTacDirect,
                transNoTacIndirect,
                transServiceFromOtherCountry,
                transForeignOrganization,
                transTacDiaBanKK,
                transTacUBND,
                transferMethodDetail,
                transferMethodSummary,
                transferMethodCDLTHDThu,
                transferMethodCTTCTGDich,
                digital_certificates,
                usingVat,
                usingVatWithTaxFeeReceipt,
                usingSale,
                usingSaleWithTaxFeeReceipt,
                usingCommercialInvoice,
                usingSalePublicProperty,
                usingSaleNationalReserve,
                usingOther,
                usingBill,
                usingForeignSupplierInvoice,

                companyContactPerson,
                companyAddress,
                companyEmail,
                companyPhoneNumber,
                transTacQLTSCong,
              } = res.registration?.registration_1_2 || {}
              protoType.current = res.registration?.registration_3

              dispatch(setAppSpinning(false))
              console.log('company', company)
              initialRegistration = {
                ...initialRegistration,
                date: dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss'),
                companyName: company.companyName,
                companyTaxCode: company.identifyNumber || company.taxCode,
                taxAuthorityName: company.taxAuthority?.name,
                taxAuthorityId: company?.taxAuthority?.taxAuthorityId,
                companyContactPerson:
                  // companyContactPerson ||
                  company.contactPersonName || companyContactPerson,
                // company?.contactTaxInfo?.fullname ||
                // company.contactPersonName,
                companyAddress:
                  // companyAddress ||
                  company.businessPermitAddress || companyAddress,
                // company?.contactTaxInfo?.address ||
                // company.businessPermitAddress,
                companyEmail:
                  // companyEmail ||
                  (window.location.pathname == '/hoa-don-dau-ra/to-khai/tao'
                    ? company?.companyEmail
                    : '') || companyEmail,
                // company?.contactTaxInfo?.email ||
                // company.contactPersonEmail,
                companyPhoneNumber:
                  // companyPhoneNumber ||
                  (window.location.pathname == '/hoa-don-dau-ra/to-khai/tao'
                    ? company?.companyPhone
                    : '') || companyPhoneNumber,
                // company?.contactTaxInfo?.phone ||
                // company.contactPersonPhone,

                type: type ?? initialRegistration.type,
                no: no || initialRegistration.no,
                formPosTaxAuthCode:
                  formPosTaxAuthCode == undefined ? 0 : formPosTaxAuthCode,
                formWithTaxAuthCode:
                  !formWithTaxAuthCode &&
                  !formPosTaxAuthCode &&
                  !formWithoutTaxAuthCode &&
                  !usingPosInvoiceWithoutTaxCode
                    ? 1
                    : formWithTaxAuthCode,
                formWithoutTaxAuthCode:
                  formWithoutTaxAuthCode == undefined
                    ? 0
                    : formWithoutTaxAuthCode,
                usingPosInvoiceWithoutTaxCode:
                  usingPosInvoiceWithoutTaxCode == undefined
                    ? 0
                    : usingPosInvoiceWithoutTaxCode,
                transNoTacDirect:
                  transNoTacDirect == undefined ? 0 : transNoTacDirect,
                transNoTacIndirect:
                  transNoTacIndirect == undefined ? 0 : transNoTacIndirect,
                transServiceFromOtherCountry:
                  transServiceFromOtherCountry == undefined
                    ? 0
                    : transServiceFromOtherCountry,
                transForeignOrganization:
                  transForeignOrganization == undefined
                    ? 0
                    : transForeignOrganization,
                transTacDiaBanKK:
                  transTacDiaBanKK == undefined ? 0 : transTacDiaBanKK,
                transTacUBND: transTacUBND == undefined ? 0 : transTacUBND,
                transferMethodDetail:
                  !formWithTaxAuthCode &&
                  !formPosTaxAuthCode &&
                  !formWithoutTaxAuthCode &&
                  !usingPosInvoiceWithoutTaxCode
                    ? 1
                    : transferMethodDetail,
                transferMethodSummary:
                  transferMethodSummary == undefined
                    ? 0
                    : transferMethodSummary,
                transferMethodCDLTHDThu:
                  transferMethodCDLTHDThu == undefined
                    ? 0
                    : transferMethodCDLTHDThu,
                transferMethodCTTCTGDich:
                  transferMethodCTTCTGDich == undefined
                    ? 0
                    : transferMethodCTTCTGDich,

                locationName: company?.province?.name,
                digital_certificates,
                usingVat: usingVat ?? initialRegistration.usingVat,
                usingVatWithTaxFeeReceipt: usingVatWithTaxFeeReceipt || 0,
                usingSale: usingSale || 0,
                usingSaleWithTaxFeeReceipt: usingSaleWithTaxFeeReceipt || 0,
                usingCommercialInvoice: usingCommercialInvoice || 0,
                usingSalePublicProperty: usingSalePublicProperty || 0,
                usingSaleNationalReserve: usingSaleNationalReserve || 0,
                usingOther: usingOther || 0,
                usingBill: usingBill || 0,
                usingForeignSupplierInvoice: usingForeignSupplierInvoice || 0,

                // Nghị định 70
                transTacQLTSCong:
                  transTacQLTSCong == undefined ? 0 : transTacQLTSCong,
                service_provider: defaultServiceProviderValue(),
                e_invoice_connector: defaultEInvoiceConnectorValue,
                dependent_units_invoice_access: [],
                e_invoice_suspend_request: [],

                //Nếu là thêm mới tờ khai lấy thông tin từ tờ khai cũ khi thêm tờ khai mới (gồm cccd/số hộ chiếu/giới tính/ngày sinh và các bảng 6,7,8,9)
                // cccd
                ...(!registrationId &&
                res.registration?.registrationDraft_near?.citizenId
                  ? {
                      citizenId:
                        res.registration?.registrationDraft_near?.citizenId,
                    }
                  : {}),
                //Hộ chiếu
                ...(!registrationId &&
                res.registration?.registrationDraft_near?.passportNumber
                  ? {
                      passportNumber:
                        res.registration?.registrationDraft_near
                          ?.passportNumber,
                    }
                  : {}),
                //Giới tính
                ...(!registrationId &&
                res.registration?.registrationDraft_near?.gender
                  ? {
                      gender: res.registration?.registrationDraft_near?.gender,
                    }
                  : {}),
                //ngày sinh
                ...(!registrationId &&
                res.registration?.registrationDraft_near?.dateOfBirth
                  ? {
                      dateOfBirth: dayjs(
                        res.registration.registrationDraft_near.dateOfBirth,
                      )
                        .hour(12) // giờ Việt Nam
                        .minute(0)
                        .second(0)
                        .millisecond(0)
                        .toDate(),
                    }
                  : {}),
              }
              //Bảng Tổ chức cung cấp dịch vụ cập nhật thông tin theo tờ khai gần nhất trường hợp thêm mới
              if (!registrationId && res.registration?.registrationDraft_near) {
                const unitRelations =
                  res.registration?.registrationDraft_near?.unitRelations ?? []
                const {
                  SERVICE_PROVIDER: service_provider = [],
                  E_INVOICE_CONNECTOR: e_invoice_connector = [],
                  DEPENDENT_UNITS_INVOICE_ACCESS:
                    dependent_units_invoice_access = [],
                  E_INVOICE_SUSPEND_REQUEST: e_invoice_suspend_request = [],
                } = unitRelations.reduce((acc, u) => {
                  if (!u) return acc

                  // clone object để không đụng vào dữ liệu gốc
                  const { unitRelationId, ...rest } = u
                  ;(acc[u.type] ??= []).push(rest)

                  return acc
                }, {})
                initialRegistration.service_provider =
                  service_provider.length > 0
                    ? service_provider
                    : defaultServiceProviderValue()
                initialRegistration.e_invoice_connector =
                  e_invoice_connector.length > 0
                    ? e_invoice_connector
                    : defaultEInvoiceConnectorValue
                initialRegistration.dependent_units_invoice_access =
                  dependent_units_invoice_access
                initialRegistration.e_invoice_suspend_request =
                  e_invoice_suspend_request
              }

              console.log('initialRegistration', initialRegistration)
              console.log('registration', registration)
              setRegistration(initialRegistration)
            } catch (e) {
              dispatch(setAppSpinning(false))
              console.log(e)
            } finally {
              gotDetailRegistration.current = true
            }
          })()
      }
    }
  }, [registrationId, company, userFunction, listFunction])

  useEffect(() => {
    if (selectedDigitalCertificate) {
      let existed = selectedCertificates
        .concat(registration?.digital_certificates ?? [])
        .find((s) =>
          Utils.shallowEqualCertificate(s, selectedDigitalCertificate),
        )

      if (existed) return
      setSelectedCertificates((old) => [
        ...old,
        { ...selectedDigitalCertificate, type: 1 },
      ])
    }
  }, [
    registration?.digital_certificates,
    selectedCertificates,
    selectedDigitalCertificate,
  ])

  useEffect(() => {
    if (taxAuthorities2025 && registration?.taxAuthorityId) {
      let taxAuthorities = findObjectInArray(
        taxAuthorities2025,
        'taxAuthorityId',
        registration?.taxAuthorityId,
      )
      setRegistration({
        ...registration,
        provinceCode: taxAuthorities?.provinceId,
      })
    }
  }, [taxAuthorities2025, registration?.taxAuthorityId])

  useEffect(() => {
    const el = document.getElementById('dateOfBirth')
    if (!el) return

    const value = el.value
    if (!value) return

    const parsed = dayjs(value, 'DD/MM/YYYY', true) // strict mode

    // ❌ Sai định dạng → KHÔNG set
    if (!parsed.isValid()) {
      return
    }

    // ✅ Đúng định dạng mới set
    setRegistration((prev) => ({
      ...prev,
      dateOfBirth: parsed.format('YYYY-MM-DD'),
    }))
  }, [registration?.dateOfBirth])

  const hsmSign = async (registrationId) => {
    try {
      dispatch(setAppSpinning(true))

      await registrationApi.hsmSignRegistration({
        registrationId,
      })
      dispatch(setAppSpinning(false))

      ToastHelper.showSuccess('Ký tờ khai thành công')

      if (systemType?.invoice) navigate('/hoa-don-dau-ra/to-khai')
      if (systemType?.ticket) navigate('/hoa-don-dau-ra/tem-ve/to-khai')
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }
  }

  const isVietnamese = (registration?.nationalityCode ?? 'VN') === 'VN'

  const sellerInfo = useMemo(
    () => [
      {
        label: 'Người liên hệ',
        value: registration?.companyContactPerson,
        isRequired: true,
        fieldName: 'companyContactPerson',
      },
      {
        label: 'Số điện thoại',
        value: registration?.companyPhoneNumber,
        isRequired: true,
        fieldName: 'companyPhoneNumber',
      },
      ...(isVietnamese
        ? [
            {
              label: 'Số CC/CCCD/số định danh',
              value: registration?.citizenId,
              isRequired: true,
              fieldName: 'citizenId',
            },
          ]
        : []),
      {
        label: 'Số hộ chiếu',
        value: registration?.passportNumber,
        isRequired: !isVietnamese,
        fieldName: 'passportNumber',
      },
      {
        label: 'Quốc tịch',
        value: registration?.nationalityCode ?? 'VN',
        isRequired: true,
        fieldName: 'nationalityCode',
        type: 'select',
        defaultValue: { value: null, label: 'Chọn quốc tịch' },
        options: (Array.isArray(countryList) ? countryList : []).map((c) => ({
          value: c.code,
          label: c.name,
        })),
        onChange: (selectedOption) => {
          setRegistration((prev) => ({
            ...prev,
            nationalityCode: selectedOption?.value ?? '',
            nationalityName: selectedOption?.label ?? '',
          }))
        },
      },
      {
        label: 'Năm sinh',
        value: registration?.dateOfBirth,
        isRequired: true,
        fieldName: 'dateOfBirth',
        type: 'date',
        id: 'dateOfBirth',
      },
      {
        label: 'Giới tính',
        value: registration?.gender,
        isRequired: true,
        fieldName: 'gender',
        type: 'radio',
        options: [
          { label: 'Nam', value: 1 },
          { label: 'Nữ', value: 0 },
        ],
        radioGroupStyle: {
          display: 'flex',
          alignItems: 'center',
          gap: '15px',
        },
      },
      {
        label: 'Địa chỉ liên hệ của NNT',
        value: registration?.companyAddress,
        isRequired: true,
        fieldName: 'companyAddress',
        isFullWidth: true,
        tooltip: taxpayerInfoTooltip,
      },
      // {
      //   label: 'Cơ quan thuế quản lý',
      //   value: registration?.taxAuthorityName,
      //   isRequired: true,
      //   fieldName: 'taxAuthorityName',
      // },

      {
        label: 'Thư điện tử của NNT',
        value: registration?.companyEmail,
        isRequired: true,
        fieldName: 'companyEmail',
      },
    ],
    [registration, countryList, isVietnamese],
  )

  const activeInvoiceTypes = useMemo(
    () => [
      { label: 'Hóa đơn GTGT', fieldName: 'usingVat' },
      {
        label: 'Hóa đơn GTGT tích hợp biên lai thu thuế, phí, lệ phí',
        fieldName: 'usingVatWithTaxFeeReceipt',
      },
      { label: 'Hóa đơn bán hàng', fieldName: 'usingSale' },
      {
        label: 'Hóa đơn bán hàng tích hợp biên lai thu thuế, phí, lệ phí',
        fieldName: 'usingSaleWithTaxFeeReceipt',
      },
      { label: 'Hóa đơn thương mại', fieldName: 'usingCommercialInvoice' },
      {
        label: 'Hóa đơn bán tài sản công',
        fieldName: 'usingSalePublicProperty',
      },
      {
        label: 'Hóa đơn bán hàng dự trữ quốc gia',
        fieldName: 'usingSaleNationalReserve',
      },
      { label: 'Các loại hóa đơn khác', fieldName: 'usingOther' },
      {
        label:
          'Các chứng từ được in, phát hành, sử dụng và quản lý như hóa đơn',
        fieldName: 'usingBill',
      },
      {
        label:
          'Hóa đơn nhà cung cấp nước ngoài không có cơ sở thường trú tại Việt Nam',
        fieldName: 'usingForeignSupplierInvoice',
      },
    ],
    [],
  )

  async function handlePressedAddDigitalCertificate() {
    const taxCode = setTaxCode(company.taxCode, company)
    const res = await toolApi.genToolUrl({
      param2: 'addDigitalSignature',
      param3: taxCode,
    })
    let { url } = res
    if (url) {
      let notInstalledCb = () => {
        // action
        // alert('Chua cai tool!')
        viewPopupSettingTool()
      }

      customProtocolCheck(
        url,
        notInstalledCb,
        () => {
          Utils.openInCurrentTab(url)
        },
        2500,
      )

      let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
      wsHelperInstance.onAddingDigitalCertificate(accessToken)
    }
  }

  function validateIdentityNumber() {
    const identityNumber = isVietnamese
      ? registration?.citizenId
      : registration?.passportNumber
    if (String(identityNumber ?? '').trim()) return true

    ToastHelper.showError(
      isVietnamese
        ? 'Vui lòng nhập số CCCD/số định danh.'
        : 'Vui lòng nhập số hộ chiếu.',
    )
    return false
  }

  function omitCitizenIdForForeignNationality(params) {
    if ((params.nationalityCode ?? 'VN') === 'VN') return params

    const paramsWithoutCitizenId = { ...params }
    delete paramsWithoutCitizenId.citizenId
    return paramsWithoutCitizenId
  }

  async function handleCreateRegistration() {
    if (!validateIdentityNumber()) return

    let { digital_certificates, ...params } = registration

    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = omitCitizenIdForForeignNationality({ ...params, certificates })

    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.createRegistration(params)
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }

    if (response?.registration) {
      if (response?.registration?.type == 3)
        ToastHelper.showSuccess('Chuyển đổi tờ khai thành công')
      else ToastHelper.showSuccess('Lưu nháp tờ khai thành công')

      if (systemType?.invoice) navigate('/hoa-don-dau-ra/to-khai')
      if (systemType?.ticket) navigate('/hoa-don-dau-ra/tem-ve/to-khai')
    }
  }

  async function handleCreateAndSignRegistration() {
    if (!validateIdentityNumber()) return

    setInforSaveAndSign({ disabled: true })
    let { digital_certificates, ...params } = registration
    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = omitCitizenIdForForeignNationality({ ...params, certificates })

    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.createRegistration(params)
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      setInforSaveAndSign({ disabled: false })
      dispatch(setAppSpinning(false))
    }

    await dispatch(
      thunkGetCompanyProfile({ companyId: company?.companyId }),
    ).unwrap()

    if (response?.registration) {
      const registrationId = response.registration.registrationId

      let activeSigningMethod = company?.activeSigningMethod
      if (activeSigningMethod == 'HSM') {
        await hsmSign(registrationId)
      } else {
        const { url } = await toolApi.genToolUrl({
          param2: 'toKhai100',
          param3: registrationId,
        })
        if (url) {
          let notInstalledCb = () => {
            // alert('Chua cai tool!')
            viewPopupSettingTool()
          }

          customProtocolCheck(
            url,
            notInstalledCb,
            () => {
              Utils.openInCurrentTab(url)
            },
            2500,
          )

          dispatch(setAppSpinning(true))
          wsHelperInstance.onExecutingSignRegistration(registrationId)
          Global.gExecutingSignRegistrationTimeOut = setTimeout(() => {
            dispatch(setAppSpinning(false))
          }, MAX_WAIT_SIGN_INVOICE)
        }
      }
    }
  }

  async function handleUpdateRegistration() {
    if (!validateIdentityNumber()) return

    let { digital_certificates, ...params } = registration
    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []

    certificates.push(...selectedCertificates)

    params = omitCitizenIdForForeignNationality({ ...params, certificates })
    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.updateRegistration(
        registrationId,
        params,
      )
    } catch (e) {
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      dispatch(setAppSpinning(false))
    }
    await dispatch(
      thunkGetCompanyProfile({ companyId: company?.companyId }),
    ).unwrap()
    if (response?.registration) {
      ToastHelper.showSuccess('Cập nhật tờ khai thành công')

      if (systemType?.invoice) navigate('/hoa-don-dau-ra/to-khai')
      if (systemType?.ticket) navigate('/hoa-don-dau-ra/tem-ve/to-khai')
    }
  }

  async function handleUpdateAndSignRegistration() {
    if (!validateIdentityNumber()) return

    setInforSaveAndSign({ disabled: true })
    let { digital_certificates, ...params } = registration

    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []
    certificates.push(...selectedCertificates)

    params = omitCitizenIdForForeignNationality({ ...params, certificates })

    dispatch(setAppSpinning(true))
    var response
    try {
      response = await registrationApi.updateRegistration(
        registrationId,
        params,
      )
    } catch (e) {
      console.log(e)
      if (e?.response?.data?.metadata?.disabled)
        handleShowModalWarning(e?.response?.data.message)
    } finally {
      setInforSaveAndSign({ disabled: false })
      dispatch(setAppSpinning(false))
    }

    if (response?.registration) {
      const registrationId = response.registration.registrationId

      let activeSigningMethod = company?.activeSigningMethod
      if (activeSigningMethod == 'HSM') {
        await hsmSign(registrationId)
      } else {
        const { url } = await toolApi.genToolUrl({
          param2: 'toKhai100',
          param3: registrationId,
        })
        if (url) {
          let notInstalledCb = () => {
            // alert('Chua cai tool!')
            viewPopupSettingTool()
          }

          customProtocolCheck(
            url,
            notInstalledCb,
            () => {
              Utils.openInCurrentTab(url)
            },
            2500,
          )

          dispatch(setAppSpinning(true))
          wsHelperInstance.onExecutingSignRegistration(registrationId)
          Global.gExecutingSignRegistrationTimeOut = setTimeout(() => {
            dispatch(setAppSpinning(false))
          }, MAX_WAIT_SIGN_REGISTRATION)
        }
      }
    }
  }

  const changeRegistrationProperty = useCallback((prop, value) => {
    console.log('log props of changeRegistrationProperty', { prop, value })
    setRegistration((old) => {
      const _registration = { ...old, [prop]: value }
      const {
        formWithTaxAuthCode,
        formWithoutTaxAuthCode,
        formPosTaxAuthCode,
        usingPosInvoiceWithoutTaxCode,

        usingVat,
        usingVatWithTaxFeeReceipt,
        usingSale,
        usingSaleWithTaxFeeReceipt,
        usingCommercialInvoice,
        usingSalePublicProperty,
        usingSaleNationalReserve,
        usingOther,
        usingBill,
        usingForeignSupplierInvoice,
      } = _registration

      // Nếu không chọn bất ký hình thức hóa đơn nào hoặc không chọn bất kỳ loại hóa đơn nào,
      if (
        (!formWithTaxAuthCode &&
          !formWithoutTaxAuthCode &&
          !formPosTaxAuthCode &&
          !usingPosInvoiceWithoutTaxCode) ||
        (!usingVat &&
          !usingVatWithTaxFeeReceipt &&
          !usingSale &&
          !usingSaleWithTaxFeeReceipt &&
          !usingCommercialInvoice &&
          !usingSalePublicProperty &&
          !usingSaleNationalReserve &&
          !usingOther &&
          !usingBill &&
          !usingForeignSupplierInvoice)
      ) {
        return old
      }

      if (prop == 'type') {
        if (!protoType.current?.no && value == 3)
          return { ..._registration, no: '' }
        if (!protoType.current?.no && value != 3)
          return { ..._registration, no: initialRegistration.no }
        if (protoType.current?.no && value == 3)
          return { ..._registration, no: protoType.current?.no }
      }
      return _registration
    })
  }, [])

  function changeModalProperty(prop, value) {
    setShowModal((old) => ({ ...old, [prop]: value }))
  }

  function changeCertType(certsName, index, value) {
    if (certsName == 'selectedCertificates') {
      setSelectedCertificates((old) =>
        old.map((item, i) => (i == index ? { ...item, type: value } : item)),
      )
    } else if (certsName == 'digital_certificates') {
      setRegistration((old) => ({
        ...old,
        digital_certificates: old.digital_certificates.map((item, i) =>
          i == index
            ? {
                ...item,
                registration_cert: { ...item.registration_cert, type: value },
              }
            : item,
        ),
      }))
    }
  }

  async function handlePrintRegistration() {
    let { digital_certificates, ...params } = registration

    let certificates =
      digital_certificates?.map((cer) => {
        let { registration_cert, ...rest } = cer
        rest.type = registration_cert?.type

        return rest
      }) || []
    certificates.push(...selectedCertificates)

    params = { ...params, certificates }
    let res

    dispatch(setAppSpinning(true))
    try {
      res = await registrationApi.exportRegistration(params)
      let newFile = new File(
        [res],
        'Tờ khai đăng ký/thay đổi thông tin sử dụng hóa đơn.pdf',
        {
          type: 'application/pdf',
        },
      )
      var fileURL = URL.createObjectURL(newFile)
      window.open(fileURL, '_blank')
    } catch (e) {
      console.log(e)
    } finally {
      dispatch(setAppSpinning(false))
    }
  }

  async function handleAddDigitalCertificateHSM(values) {
    dispatch(setAppSpinning(true))
    try {
      let res = await registrationApi.getCertificateDetailHSM({
        hsmAgreementUUID: values.agreementUUID,
      })
      dispatch(setAppSpinning(false))
      if (res?.result == 'success') {
        res = res.data

        dispatch(setSelectedDigitalCertificate(res))
        changeModalProperty('connectConfig', false)
      }
    } catch (e) {
      dispatch(setAppSpinning(false))
      throw new Error(e.message)
    }
  }

  async function handleAddDigitalCertificateMannual(values) {
    dispatch(setSelectedDigitalCertificate(values))
    changeModalProperty('signatureInfo', false)
  }

  function handleShowModalChooseSignMethod() {
    changeModalProperty('chooseSignMethod', true)
  }

  const { data: banners, isLoading } = useQuery({
    staleTime: 1000 * 60 * 5,
    queryKey: ['banner'],
    queryFn: ({ signal }) =>
      axiosClient.get('/notification-marquee/show', {
        signal,
      }),
  })

  if (isLoading) {
    return null
  }

  function handleShowModalWarning(_message) {
    changeModalProperty('warning', { visible: true, message: _message })
  }

  // Tạo các hàm xử lý riêng biệt cho từng checkbox
  const handleFormWithTaxAuthCodeChange = (checked) => {
    const value = booleanToNumber(checked)

    // Cập nhật giá trị chính
    changeRegistrationProperty('formWithTaxAuthCode', value)

    // Xử lý các trường phụ thuộc
    if (!value && !registration.formPosTaxAuthCode) {
      // Nếu cả hai checkbox đều không được chọn, reset các trường phụ thuộc
      if (registration.transTacDiaBanKK) {
        changeRegistrationProperty('transTacDiaBanKK', 0)
      }

      if (registration.transTacUBND) {
        changeRegistrationProperty('transTacUBND', 0)
      }
      if (registration.transTacQLTSCong) {
        changeRegistrationProperty('transTacQLTSCong', 0)
      }
    }

    // Đảm bảo phương thức chuyển dữ liệu được chọn khi checkbox được chọn
    if (value && !registration.transferMethodDetail) {
      changeRegistrationProperty('transferMethodDetail', 1)
    }
  }

  const handleFormPosTaxAuthCodeChange = (checked) => {
    const value = booleanToNumber(checked)

    // Cập nhật giá trị chính
    changeRegistrationProperty('formPosTaxAuthCode', value)

    // Xử lý các trường phụ thuộc
    if (!value && !registration.formWithTaxAuthCode) {
      // Nếu cả hai checkbox đều không được chọn, reset các trường phụ thuộc
      if (registration.transTacDiaBanKK) {
        changeRegistrationProperty('transTacDiaBanKK', 0)
      }

      if (registration.transTacUBND) {
        changeRegistrationProperty('transTacUBND', 0)
      }

      if (registration.transTacQLTSCong) {
        changeRegistrationProperty('transTacQLTSCong', 0)
      }
    }

    // Đảm bảo phương thức chuyển dữ liệu được chọn khi checkbox được chọn
    if (value && !registration.transferMethodDetail) {
      changeRegistrationProperty('transferMethodDetail', 1)
    }
  }

  // Tạo một hàm xử lý riêng cho checkbox này
  const handleFormWithoutTaxAuthCodeChange = (checked) => {
    const value = booleanToNumber(checked)

    // Cập nhật giá trị chính
    changeRegistrationProperty('formWithoutTaxAuthCode', value)

    // Xử lý các trường phụ thuộc
    if (!value) {
      if (!registration.usingPosInvoiceWithoutTaxCode) {
        changeRegistrationProperty('transNoTacIndirect', 0)
        changeRegistrationProperty('transferMethodSummary', 0)
        changeRegistrationProperty('transServiceFromOtherCountry', 0)
        changeRegistrationProperty('transForeignOrganization', 0)
      }
    } else if (value && !registration.transNoTacIndirect) {
      // Nếu chọn và transNoTacIndirect chưa được chọn, tự động chọn nó
      changeRegistrationProperty('transNoTacIndirect', 1)
    }
  }

  const handleUsingPosInvoiceWithoutTaxCodeChange = (checked) => {
    const value = booleanToNumber(checked)

    changeRegistrationProperty('usingPosInvoiceWithoutTaxCode', value)

    if (!value) {
      if (!registration.formWithoutTaxAuthCode) {
        changeRegistrationProperty('transNoTacIndirect', 0)
        changeRegistrationProperty('transferMethodSummary', 0)
        changeRegistrationProperty('transServiceFromOtherCountry', 0)
        changeRegistrationProperty('transForeignOrganization', 0)
      }
    } else if (!registration.transNoTacIndirect) {
      changeRegistrationProperty('transNoTacIndirect', 1)
    }
  }

  const handleTransTacCheckboxChange = (checked) => {
    const value = booleanToNumber(checked)

    // Cập nhật cả hai trường liên quan
    changeRegistrationProperty('transTacDiaBanKK', value)
    changeRegistrationProperty('transTacUBND', value)
    changeRegistrationProperty('transTacQLTSCong', value)
  }

  const handleTransTacDiaBanKKChange = (checked) => {
    changeRegistrationProperty('transTacDiaBanKK', booleanToNumber(checked))
  }

  const handleTransTacUBNDChange = (checked) => {
    changeRegistrationProperty('transTacUBND', booleanToNumber(checked))
  }

  const handleTransTacQLTSCongChange = (checked) => {
    changeRegistrationProperty('transTacQLTSCong', booleanToNumber(checked))
  }

  const handleTransNoTacIndirectChange = (checked) => {
    changeRegistrationProperty('transNoTacIndirect', booleanToNumber(checked))
  }

  const handleTransForeignOrganizationChange = (checked) => {
    changeRegistrationProperty(
      'transForeignOrganization',
      booleanToNumber(checked),
    )
  }

  // const handleTransServiceFromOtherCountryChange = (checked) => {
  //   changeRegistrationProperty(
  //     'transServiceFromOtherCountry',
  //     booleanToNumber(checked),
  //   )
  // }

  const handleTransferMethodDetailChange = (checked) => {
    changeRegistrationProperty('transferMethodDetail', booleanToNumber(checked))
  }

  const handleTransferMethodSummaryChange = (checked) => {
    changeRegistrationProperty(
      'transferMethodSummary',
      booleanToNumber(checked),
    )
  }

  const handleTransferMethodCDLTHDThuChange = (checked) => {
    changeRegistrationProperty(
      'transferMethodCDLTHDThu',
      booleanToNumber(checked),
    )
  }

  const handleTransferMethodCTTCTGDichChange = (checked) => {
    changeRegistrationProperty(
      'transferMethodCTTCTGDich',
      booleanToNumber(checked),
    )
  }

  const handleInvoiceTypeChange = (fieldName, checked) => {
    changeRegistrationProperty(fieldName, booleanToNumber(checked))
  }

  const handleRegistrationTypeChange = (value) => {
    changeRegistrationProperty('type', value)
    if (value == 3) {
      changeRegistrationProperty('usingSalePublicProperty', 0)
      changeRegistrationProperty('usingSaleNationalReserve', 0)
      changeRegistrationProperty('usingBill', 0)
    }
  }

  return (
    <div className="CreateRegistration">
      <PrivateBaseLayout nonPadding nonPageUpBtn>
        {registration && (
          <>
            <div className="registration-container mb-5">
              <div className="registration-paper mx-auto">
                <div className="d-flex flex-column justify-content-center">
                  <div className="text-center pt-5">
                    <div
                      className="text-uppercase font-sfpro-bold"
                      style={{ fontSize: '20px', fontWeight: '400' }}
                    >
                      Tờ khai
                    </div>

                    <div
                      className="font-sfpro-bold"
                      style={{ fontSize: '16px', fontWeight: '400' }}
                    >
                      Đăng ký/Thay đổi thông tin sử dụng hóa đơn điện tử
                    </div>

                    <div
                      className="d-flex justify-content-center align-items-end"
                      style={{ minHeight: '44px', paddingBottom: '8px' }}
                    >
                      {registrationType?.map((item, index) => {
                        if (
                          screenAction == 'sua' &&
                          registrationExisted?.type == 3 &&
                          (item.value == 1 || item.value == 2)
                        )
                          return
                        return (
                          <div key={index} className="form-check mr-5">
                            <input
                              className="form-check-input cursor-pointer"
                              type="radio"
                              name={`registration-${item.value}`}
                              id={`registration-${item.value}`}
                              value={item.value}
                              readOnly={screenAction == 'xem'}
                              checked={registration.type == item.value}
                              onChange={(e) =>
                                handleRegistrationTypeChange(e.target.value)
                              }
                              disabled={registrationExisted?.type == 3}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`registration-${item.value}`}
                            >
                              {item.label}
                            </label>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Số quyết định:</div>
                  <div>
                    <input
                      type="text"
                      className="form-control input-dot"
                      readOnly={screenAction == 'xem'}
                      value={registration.no}
                      onChange={(e) =>
                        changeRegistrationProperty('no', e.target.value?.trim())
                      }
                      required
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Ngày lập:</div>
                  <div>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      customInput={
                        <input
                          type="text"
                          className="form-control input-dot input-date"
                        />
                      }
                      onChangeRaw={(e) => {
                        const newDate = dayjs(
                          e?.target?.value?.trim(),
                          'DD/MM/YYYY',
                          true,
                        )
                        if (newDate.isValid()) {
                          changeRegistrationProperty(
                            'date',
                            dayjs(newDate).format('YYYY-MM-DD HH:mm:ss'),
                          )
                        }
                      }}
                      // showIcon={true}
                      todayButton={<button>Hôm nay</button>}
                      readOnly={screenAction == 'xem'}
                      selected={new Date(registration.date) || new Date()}
                      onChange={(date) => {
                        date &&
                          changeRegistrationProperty(
                            'date',
                            dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
                          )
                      }}
                    />
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">
                    Tên người nộp thuế:
                    <KTTooltip
                      overlayClassname="KTTooltipOverlay--wide"
                      element={taxpayerInfoTooltip}
                    >
                      <InfoCircleOutlined
                        style={{
                          color: '#1677ff',
                          marginLeft: 2,
                          cursor: 'pointer',
                        }}
                      />
                    </KTTooltip>
                  </div>
                  <div>{registration.companyName}</div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  <div className="registration-label">Mã số thuế:</div>
                  <div className="d-flex flex-row align-items-center tax-code">
                    <div className="d-flex flex-row align-items-center tax-code-input mr-2">
                      {registration.companyTaxCode
                        .split('-')
                        .at(0)
                        .split('')
                        .map((num, index) => (
                          <div key={index} className="tax-code-number">
                            {num}
                          </div>
                        ))}
                    </div>
                    <div className="d-flex flex-row align-items-center tax-code-input">
                      {(registration.companyTaxCode.split('-').at(1) || '   ')
                        .split('')
                        .map((num, index) => (
                          <div key={index} className="tax-code-number">
                            {num}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '12px' }}
                >
                  <div
                    className="registration-label"
                    style={{ lineHeight: '5px' }}
                  >
                    <p>Cơ quan thuế quản</p> lý:
                    <span className="text-danger">*</span>{' '}
                    <KTTooltip
                      overlayClassname="KTTooltipOverlay--wide"
                      element={
                        <div
                          style={{
                            color: '#212529',
                            lineHeight: 1.5,
                          }}
                        >
                          <div style={{ fontWeight: 700, marginBottom: 8 }}>
                            Khai báo Cơ quan thuế quản lý của hộ kinh doanh theo
                            hướng dẫn của cơ quan thuế
                          </div>
                          <div>
                            Cơ quan thuế quản lý: Là Thuế cơ sở quản lý địa bàn
                            nơi hộ kinh doanh đặt trụ sở.
                          </div>
                          <div>
                            Vui lòng kiểm tra lại thông tin tại{' '}
                            <strong>Hồ sơ hóa đơn điện tử</strong> để cập nhật
                            theo đúng hướng dẫn của cơ quan thuế.
                          </div>
                        </div>
                      }
                    >
                      <InfoCircleOutlined
                        style={{
                          color: '#1677ff',
                          marginLeft: 2,
                          cursor: 'pointer',
                        }}
                      />
                    </KTTooltip>
                  </div>
                  <div className="flex-grow-1">
                    <input
                      defaultValue={registration.taxAuthorityName}
                      type="text"
                      className="form-control input-dot"
                      disabled
                      style={{ display: 'none' }}
                    />

                    <SelectCustom
                      showSearch
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      style={{ width: '100%' }}
                      options={taxAuthorities2025.map((item) => ({
                        value: item.taxAuthorityId,
                        label: item.name,
                      }))}
                      notFoundContent={
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={t('taxDeduction.noData')}
                        />
                      }
                      onChange={(value) => {
                        let dataOption = findObjectInArray(
                          taxAuthorities2025,
                          'taxAuthorityId',
                          value,
                        )
                        setRegistration({
                          ...registration,
                          taxAuthorityName: dataOption?.name,
                          taxAuthorityId: value,
                        })
                      }}
                      value={
                        taxAuthorities2025.some(
                          (item) =>
                            item.taxAuthorityId === registration.taxAuthorityId,
                        )
                          ? registration.taxAuthorityId
                          : null
                      }
                    ></SelectCustom>
                  </div>
                </div>
                <div
                  className="d-flex flex-row align-items-center p-3"
                  style={{
                    fontSize: '13.5px',
                    fontStyle: 'italic',
                    backgroundColor: '#eaff0e63',
                  }}
                >
                  <div className="mr-2">
                    <i
                      className="fa-solid fa-lightbulb-on fa-lg"
                      style={{ color: '#efd358' }}
                    ></i>
                  </div>
                  <div className="remind">
                    <p className="mb-0 remind-subtitle">
                      Sau khi tờ khai được <b>chấp nhận</b>, cơ quan thuế sẽ{' '}
                      <b>gửi các thông báo quan trọng</b> liên quan đến hóa đơn
                      điện tử tới email/số điện thoại/địa chỉ này.
                    </p>
                  </div>
                </div>
                {sellerInfo?.map((item, index) => {
                  return (
                    <div
                      className="d-flex align-items-end registration-field-row"
                      style={{ minHeight: '44px', paddingBottom: '8px' }}
                      key={index}
                    >
                      <div className="registration-label registration-field-label">
                        {item.label}:
                        {item.isRequired && (
                          <span className="text-danger">*</span>
                        )}
                        {item.tooltip && (
                          <KTTooltip
                            overlayClassname="KTTooltipOverlay--wide"
                            element={item.tooltip}
                          >
                            <InfoCircleOutlined
                              style={{
                                color: '#1677ff',
                                marginLeft: 2,
                                cursor: 'pointer',
                              }}
                            />
                          </KTTooltip>
                        )}
                      </div>
                      <div
                        className={item.isFullWidth ? 'flex-grow-1' : ''}
                        style={{ flexBasis: 'auto' }}
                      >
                        <InputField
                          item={item}
                          screenAction={screenAction}
                          changeRegistrationProperty={
                            changeRegistrationProperty
                          }
                          id={item?.id}
                        />
                      </div>
                    </div>
                  )
                })}

                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  Theo Nghị định số 254/2026/NĐ-CP và Thông tư 91/2026/TT-BTC
                  ngày 30 tháng 06 năm 2026 của Chính phủ, chúng tôi/tôi thuộc
                  đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay
                  đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa
                  đơn điện tử như sau:
                </div>
                <div>
                  <div
                    className="d-flex align-items-center font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    <span>1. Hình thức hóa đơn:</span>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => setIsInvoiceTypeGuideOpen(true)}
                      style={{
                        padding: '0 2px',
                        fontWeight: 400,
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        <QuestionCircleOutlined />
                        <span>Hướng dẫn</span>
                      </span>
                    </Button>
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        id="hasTaxAuthCode"
                        checked={registration.formWithTaxAuthCode}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) =>
                          handleFormWithTaxAuthCodeChange(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="hasTaxAuthCode"
                      >
                        Có mã của cơ quan thuế
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        id="posHasTaxAuthCode"
                        checked={registration.formPosTaxAuthCode}
                        readOnly={screenAction == 'xem'}
                        onChange={(e) =>
                          handleFormPosTaxAuthCodeChange(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="posHasTaxAuthCode"
                      >
                        Có mã của cơ quan thuế (Khởi tạo từ máy tính tiền)
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        id="hasNotTaxAuthCode"
                        checked={registration.formWithoutTaxAuthCode}
                        disabled={screenAction === 'xem' || isHouseholdCompany}
                        onChange={(e) =>
                          handleFormWithoutTaxAuthCodeChange(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="hasNotTaxAuthCode"
                      >
                        Không có mã của cơ quan thuế
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        id="posWithoutTaxAuthCode"
                        checked={registration.usingPosInvoiceWithoutTaxCode}
                        disabled={screenAction === 'xem' || isHouseholdCompany}
                        onChange={(e) =>
                          handleUsingPosInvoiceWithoutTaxCodeChange(
                            e.target.checked,
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="posWithoutTaxAuthCode"
                      >
                        Không có mã của cơ quan thuế (khởi tạo từ máy tính tiền)
                      </label>
                    </div>
                  </div>
                </div>
                <div className="taxpayer">
                  <div
                    className="d-flex align-items-center font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    <span>2. Hình thức gửi dữ liệu hóa đơn điện tử:</span>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => setIsDataTransferGuideOpen(true)}
                      style={{
                        padding: '0 2px',
                        fontWeight: 400,
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        <QuestionCircleOutlined />
                        <span>Hướng dẫn</span>
                      </span>
                    </Button>
                  </div>
                  <div
                    className="d-flex flex-row align-items-center p-3"
                    style={{
                      fontSize: '13.5px',
                      fontStyle: 'italic',
                      backgroundColor: '#eaff0e63',
                    }}
                  >
                    <div className="mr-2">
                      <i
                        className="fa-solid fa-lightbulb-on fa-lg"
                        style={{ color: '#efd358' }}
                      ></i>
                    </div>
                    <div className="remind">
                      <p className="mb-0 remind-subtitle">
                        Vui lòng bỏ qua nếu bạn không thuộc đối tượng nào trong
                        các đối tượng dưới đây.
                      </p>
                    </div>
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        disabled={
                          !registration.formWithTaxAuthCode &&
                          !registration.formPosTaxAuthCode
                        }
                        readOnly={screenAction == 'xem'}
                        checked={
                          registration.transTacDiaBanKK ||
                          registration.transTacUBND ||
                          registration.transTacQLTSCong
                        }
                        onChange={(e) =>
                          handleTransTacCheckboxChange(e.target.checked)
                        }
                      />
                      <label className="form-check-label">
                        a. Trường hợp sử dụng hóa đơn điện tử có mã trên Cổng
                        thông tin điện tử của Tổng cục Thuế hoặc tổ chức cung
                        cấp dịch vụ hóa đơn điện tử được Tổng cục Thuế ủy thác
                      </label>
                      <div style={{ marginLeft: '24px' }}>
                        <div className="form-check">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            value=""
                            disabled={
                              (!registration.formWithTaxAuthCode &&
                                !registration.formPosTaxAuthCode) ||
                              (!registration.transTacDiaBanKK &&
                                !registration.transTacUBND &&
                                !registration.transTacQLTSCong)
                            }
                            readOnly={screenAction == 'xem'}
                            checked={registration.transTacDiaBanKK}
                            onChange={(e) =>
                              handleTransTacDiaBanKKChange(e.target.checked)
                            }
                          />
                          <label className="form-check-label">
                            Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân
                            kinh doanh tại địa bàn có điều kiện kinh tế xã hội
                            khó khăn, địa bàn có điều kiện kinh tế xã hội đặc
                            biệt khó khăn (điểm a khoản 1 Điều 14 của Nghị định)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            value=""
                            disabled={
                              (!registration.formWithTaxAuthCode &&
                                !registration.formPosTaxAuthCode) ||
                              (!registration.transTacDiaBanKK &&
                                !registration.transTacUBND &&
                                !registration.transTacQLTSCong)
                            }
                            readOnly={screenAction == 'xem'}
                            checked={registration.transTacQLTSCong}
                            onChange={(e) =>
                              handleTransTacQLTSCongChange(e.target.checked)
                            }
                          />
                          <label className="form-check-label">
                            Cơ quan thuế hoặc cơ quan được giao nhiệm vụ tổ
                            chức, xử lý tài sản công theo quy định pháp luật về
                            quản lý, sử dụng tài sản công (khoản 1 Điều 15 Nghị
                            định)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        checked={
                          registration.transNoTacDirect ||
                          registration.transNoTacIndirect ||
                          registration.transServiceFromOtherCountry ||
                          registration.transForeignOrganization
                        }
                        onChange={(e) => {
                          changeRegistrationProperty(
                            'transNoTacIndirect',
                            e.target.checked ? 1 : 0,
                          )
                        }}
                      />
                      <label className="form-check-label">
                        b. Trường hợp sử dụng hóa đơn điện tử không có mã của cơ
                        quan thuế:
                      </label>
                      <div style={{ marginLeft: '24px' }}>
                        <div className="form-check">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            value=""
                            disabled={true}
                            readOnly={screenAction == 'xem'}
                            checked={false}
                          />
                          <label className="form-check-label">
                            Gửi trực tiếp đến cơ quan thuế (điểm b.1 khoản 3
                            Điều 16 Nghị định 254).
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            value=""
                            disabled={true}
                            readOnly={screenAction == 'xem'}
                            checked={registration.transNoTacIndirect}
                            onChange={(e) =>
                              handleTransNoTacIndirectChange(e.target.checked)
                            }
                          />
                          <label className="form-check-label">
                            Gửi đến cơ quan thuế thông qua tổ chức cung cấp dịch
                            vụ hóa đơn điện tử (điểm b.2 khoản 3 Điều 16 Nghị
                            định 254).
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            // disabled={
                            //   screenAction === 'xem' ||
                            //   (!registration.formWithoutTaxAuthCode &&
                            //     !registration.usingPosInvoiceWithoutTaxCode)
                            // }
                            // value=""
                            disabled={true}
                            readOnly={screenAction == 'xem'}
                            // checked={registration.transForeignOrganization}
                            checked={false}
                            // onChange={(e) =>
                            //   handleTransForeignOrganizationChange(
                            //     e.target.checked,
                            //   )
                            // }
                          />
                          <label className="form-check-label">
                            Tổ chức nước ngoài có hoạt động kinh doanh, cung cấp
                            dịch vụ thông qua nền tảng thương mại điện tử, nền
                            tảng số khác (điểm a.1.3 khoản 3 Điều 16 NĐ 254)
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="d-flex align-items-center font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    <span>3. Phương thức chuyển dữ liệu hóa đơn điện tử:</span>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => setIsTransferMethodGuideOpen(true)}
                      style={{
                        padding: '0 2px',
                        fontWeight: 400,
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        <QuestionCircleOutlined />
                        <span>Hướng dẫn</span>
                      </span>
                    </Button>
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        id=""
                        disabled={
                          (!registration.formWithoutTaxAuthCode &&
                            !registration.usingPosInvoiceWithoutTaxCode) ||
                          registration.formWithTaxAuthCode ||
                          registration.formPosTaxAuthCode
                        }
                        readOnly={screenAction == 'xem'}
                        checked={registration.transferMethodDetail}
                        onChange={(e) =>
                          handleTransferMethodDetailChange(e.target.checked)
                        }
                      />
                      <label className="form-check-label" htmlFor="">
                        Chuyển đầy đủ nội dung từng hóa đơn
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        value=""
                        id=""
                        // disabled={
                        //   !registration.formWithoutTaxAuthCode &&
                        //   !registration.usingPosInvoiceWithoutTaxCode
                        // }
                        disabled={true}
                        readOnly={screenAction == 'xem'}
                        checked={registration.transferMethodSummary}
                        onChange={(e) =>
                          handleTransferMethodSummaryChange(e.target.checked)
                        }
                      />
                      <label className="form-check-label" htmlFor="">
                        Chuyển dữ liệu hóa đơn điện tử theo Bảng tổng hợp dữ
                        liệu hóa đơn điện tử theo Mẫu số 01/TH-HĐĐT(điểm b khoản
                        6 Điều 4 TT 91)
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        id="transferMethodCTTCTGDich"
                        // disabled={
                        //   screenAction === 'xem' ||
                        //   (!registration.formWithoutTaxAuthCode &&
                        //     !registration.usingPosInvoiceWithoutTaxCode)
                        // }
                        disabled={true}
                        checked={registration.transferMethodCTTCTGDich}
                        onChange={(e) =>
                          handleTransferMethodCTTCTGDichChange(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="transferMethodCTTCTGDich"
                      >
                        Chuyển cơ sở dữ liệu thông tin chi tiết giao dịch theo
                        Bảng 01/TTGD (điểm c khoản 6 Điều 4 TT 91)
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        id="transferMethodCDLTHDThu"
                        // disabled={
                        //   screenAction === 'xem' ||
                        //   (!registration.formWithoutTaxAuthCode &&
                        //     !registration.usingPosInvoiceWithoutTaxCode)
                        // }
                        disabled={true}
                        checked={registration.transferMethodCDLTHDThu}
                        onChange={(e) =>
                          handleTransferMethodCDLTHDThuChange(e.target.checked)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="transferMethodCDLTHDThu"
                      >
                        Chuyển dữ liệu tổng hợp doanh thu theo Bảng tổng hợp
                        doanh thu (điểm a khoản 6 Điều 4 TT 91)
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className="d-flex align-items-center font-sfpro-bold"
                    style={{ minHeight: '44px', paddingBottom: '8px' }}
                  >
                    <span>4. Loại hóa đơn sử dụng:</span>
                    <Button
                      type="link"
                      size="small"
                      onClick={() => setIsInvoiceTypeListGuideOpen(true)}
                      style={{
                        padding: '0 2px',
                        fontWeight: 400,
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 2,
                        }}
                      >
                        <QuestionCircleOutlined />
                        <span>Hướng dẫn</span>
                      </span>
                    </Button>
                  </div>
                  <div style={{ marginLeft: '24px' }}>
                    {activeInvoiceTypes.map((item, index) => {
                      return (
                        <div className="form-check" key={index}>
                          <input
                            className="form-check-input cursor-pointer"
                            type="checkbox"
                            value=""
                            id={item.fieldName}
                            checked={registration[item.fieldName]}
                            readOnly={screenAction == 'xem'}
                            onChange={(e) =>
                              handleInvoiceTypeChange(
                                item.fieldName,
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={item.fieldName}
                          >
                            {item.label}
                          </label>
                        </div>
                      )
                    })}
                  </div>
                </div>
                {
                  <ListCertificates
                    selectedCertificates={selectedCertificates}
                    registration={registration}
                    setRegistration={setRegistration}
                    cerTypeOptions={cerTypeOptions}
                    setSelectedCertificates={setSelectedCertificates}
                    screenAction={screenAction}
                    handleShowModalChooseSignMethod={
                      handleShowModalChooseSignMethod
                    }
                    changeCertType={changeCertType}
                  />
                }

                <ReusableTable
                  title={
                    <span className="d-inline-flex align-items-center">
                      <span>6. Tổ chức cung cấp dịch vụ</span>
                      <Button
                        type="link"
                        size="small"
                        onClick={() => setIsServiceProviderGuideOpen(true)}
                        style={{ padding: '0 2px', fontWeight: 400 }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <QuestionCircleOutlined />
                          <span>Hướng dẫn</span>
                        </span>
                      </Button>
                    </span>
                  }
                  columns={serviceProviderColumns}
                  data={
                    registration.service_provider || defaultServiceProviderValue
                  }
                  onChange={(val) =>
                    changeRegistrationProperty('service_provider', val)
                  }
                  showIndex={true}
                />

                <ReusableTable
                  title={
                    <span className="d-inline-flex align-items-center">
                      <span>7. Thông tin đơn vị truyền nhận</span>
                      <Button
                        type="link"
                        size="small"
                        onClick={() => setIsEInvoiceConnectorGuideOpen(true)}
                        style={{ padding: '0 2px', fontWeight: 400 }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <QuestionCircleOutlined />
                          <span>Hướng dẫn</span>
                        </span>
                      </Button>
                    </span>
                  }
                  columns={EInvoiceConnectorColumns}
                  data={
                    registration.e_invoice_connector ||
                    defaultEInvoiceConnectorValue
                  }
                  onChange={(val) =>
                    changeRegistrationProperty('e_invoice_connector', val)
                  }
                  showIndex={true}
                />
                <ReusableTable
                  title={
                    <span className="d-inline-flex align-items-center">
                      <span>
                        8. Thông tin đơn vị hạch toán phụ thuộc cần cấp quyền
                        tra cứu hóa đơn
                      </span>
                      <Button
                        type="link"
                        size="small"
                        onClick={() => setIsDependentUnitsGuideOpen(true)}
                        style={{ padding: '0 2px', fontWeight: 400 }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <QuestionCircleOutlined />
                          <span>Hướng dẫn</span>
                        </span>
                      </Button>
                    </span>
                  }
                  columns={DependentUnitsInvoiceAccess}
                  data={registration.dependent_units_invoice_access || []}
                  onChange={(val) =>
                    changeRegistrationProperty(
                      'dependent_units_invoice_access',
                      val,
                    )
                  }
                  showIndex={true}
                />
                <ReusableTable
                  title={
                    <span className="d-inline-flex align-items-center">
                      <span>9. Đề nghị tạm ngừng sử dụng hóa đơn điện tử</span>
                      <Button
                        type="link"
                        size="small"
                        onClick={() => setIsEInvoiceSuspendGuideOpen(true)}
                        style={{ padding: '0 2px', fontWeight: 400 }}
                      >
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 2,
                          }}
                        >
                          <QuestionCircleOutlined />
                          <span>Hướng dẫn</span>
                        </span>
                      </Button>
                    </span>
                  }
                  columns={EInvoiceSuspendRequest}
                  data={registration.e_invoice_suspend_request || []}
                  onChange={(val) =>
                    changeRegistrationProperty('e_invoice_suspend_request', val)
                  }
                  showIndex={true}
                />

                {/*Hiển thị khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {registration.type ==
                  REGISTRATION_TYPE.UPDATE_FROM_OTHER_SYSTEM &&
                  registration.formPosTaxAuthCode == 1 && (
                    <div>
                      <div
                        className="d-flex align-items-end font-sfpro-bold "
                        style={{ minHeight: '44px', paddingBottom: '8px' }}
                      >
                        <span>10. Cập nhật mã CQT</span>
                        <Tooltip
                          overlayStyle={{ maxWidth: '454px' }}
                          placement="topLeft"
                          title={() => {
                            return (
                              <div>
                                <ul>
                                  <li>
                                    Mã CQT gồm 5 ký tự áp dụng với hóa đơn khởi
                                    tạo từ MTT.
                                  </li>
                                  <li>
                                    Số thứ tự bắt đầu: Là số kế tiếp của mã CQT
                                    khi chuyển HĐ sang hệ thống mới.
                                  </li>
                                </ul>
                              </div>
                            )
                          }}
                          color=" #000000BF"
                        >
                          <InfoCircleOutlined
                            style={{
                              paddingBottom: '4px',
                              paddingLeft: '10px',
                            }}
                          />
                        </Tooltip>
                      </div>
                      <div style={{ marginLeft: '24px' }}>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div className="registration-label">
                            Mã CQT cấp:
                            <span className="text-danger">*</span>
                          </div>
                          <div className="" style={{ flexBasis: 'auto' }}>
                            <input
                              type="text"
                              className="form-control"
                              style={{ flex: 'auto', minWidth: '250px' }}
                              value={registration.companyIssuedTaxAuthorityCode}
                              readOnly={screenAction == 'xem'}
                              onChange={(e) => {
                                changeRegistrationProperty(
                                  'companyIssuedTaxAuthorityCode',
                                  Utils.convertString(
                                    e.target.value.trim(),
                                  ).toUpperCase(),
                                )
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{
                              minHeight: '44px',
                              paddingBottom: '8px',
                            }}
                          >
                            <div className="registration-label">
                              Số thứ tự bắt đầu
                              <span className="text-danger">*</span>
                            </div>
                            <div className="" style={{ flexBasis: 'auto' }}>
                              <input
                                min={1}
                                type="number"
                                className="form-control "
                                style={{ flex: 'auto', width: '80px' }}
                                value={registration.companyCount}
                                readOnly={screenAction == 'xem'}
                                onChange={(e) => {
                                  let _value = e?.target?.value
                                  if (_value && _value < 1) _value = 1
                                  changeRegistrationProperty(
                                    'companyCount',
                                    _value,
                                  )
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ minHeight: '44px', paddingBottom: '8px' }}
                        >
                          <div
                            className="d-flex align-items-center"
                            style={{
                              minHeight: '44px',
                              paddingBottom: '8px',
                            }}
                          >
                            <div className="registration-label">
                              Mẫu hiển thị:
                            </div>
                            <div className="" style={{ flexBasis: 'auto' }}>
                              <input
                                type="text"
                                className="form-control"
                                style={{ flex: 'auto', minWidth: '250px' }}
                                value={codeTemplate}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                <div
                  className="d-flex align-items-end"
                  style={{ minHeight: '44px', paddingBottom: '8px' }}
                >
                  Chúng tôi cam kết hoàn toàn chịu trách nhiệm trước pháp luật
                  về tính chính xác, trung thực của nội dung nêu trên và thực
                  hiện theo đúng quy định của pháp luật.
                </div>

                {/*Ẩn khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {registration.type !=
                  REGISTRATION_TYPE.UPDATE_FROM_OTHER_SYSTEM && (
                  <div className="d-flex flex-row justify-content-between align-items-start">
                    <div>
                      <div
                        className="d-flex align-items-end"
                        style={{ minHeight: '44px', paddingBottom: '8px' }}
                      >
                        <div className="registration-label">Nơi lập:</div>
                        <div>
                          <input
                            type="text"
                            className="form-control input-dot"
                            value={registration.locationName}
                            readOnly={screenAction == 'xem'}
                            onBlur={(e) => {
                              changeRegistrationProperty(
                                'locationName',
                                e?.target?.value?.trim(),
                              )
                            }}
                            maxLength={50}
                            onChange={(e) =>
                              changeRegistrationProperty(
                                'locationName',
                                e?.target?.value,
                              )
                            }
                          />
                        </div>
                      </div>
                      {/* <div
              className="d-flex align-items-end"
              style={{ minHeight: '44px', paddingBottom: '8px' }}
            >
              <div className="registration-label">Ngày có hiệu lực:</div>
              <div>
                <input defaultValue="29/03/2023" type="text" className="form-control input-dot" />
              </div>
            </div> */}
                    </div>

                    <div className="text-center">
                      <div>{`${registration.locationName}, ngày ${dayjs(
                        registration.date,
                      ).format('DD/MM/YYYY')}`}</div>
                      <div>
                        <div className="font-sfpro-bold">
                          NGƯỜI NỘP THUẾ hoặc ĐẠI DIỆN HỢP PHÁP CỦA NGƯỜI NỘP
                          THUẾ
                        </div>
                        <div className="mb-4">
                          (Chữ ký số, chữ ký điện tử của người nộp thuế)
                        </div>
                        <button
                          className="btn btn-light d-inline-flex align-items-center"
                          style={{
                            color: '#041847',
                            backgroundColor: '#e4e6eb',
                          }}
                          onClick={
                            screenAction == 'tao'
                              ? handleCreateAndSignRegistration
                              : handleUpdateAndSignRegistration
                          }
                        >
                          <i
                            className="fal fa-file-contract"
                            style={{ color: '#041847' }}
                          ></i>
                          Ký điện tử
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              className="registration-footer d-flex flex-row justify-content-between align-items-center px-6 py-2 border-top border-secondary"
              style={banners?.data?.length > 0 ? { bottom: '30px' } : {}}
            >
              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                <i className="fa-sharp fa-regular fa-arrow-left"></i>Quay lại
              </button>
              {registration.type !=
                REGISTRATION_TYPE.UPDATE_FROM_OTHER_SYSTEM && (
                <button
                  className="btn btn-secondary"
                  onClick={handlePrintRegistration}
                >
                  <i className="fa-regular fa-print"></i>In
                </button>
              )}

              <div className="d-flex flex-row">
                {/* Ẩn khi chọn Cập nhật thông tin tờ khai từ hệ thống khác */}
                {screenAction != 'xem' && registration?.type != 3 && (
                  <button
                    className="btn btn-primary d-flex flex-row align-items-center py-2 mr-2"
                    disabled={inforSaveAndSign?.disabled}
                    onClick={
                      screenAction == 'tao'
                        ? handleCreateAndSignRegistration
                        : handleUpdateAndSignRegistration
                    }
                  >
                    <i className="fa-regular fa-pen-to-square"></i>Lưu và ký
                  </button>
                )}
                {screenAction != 'xem' && (
                  <button
                    className="btn btn-primary d-flex flex-row align-items-center py-2"
                    onClick={() => {
                      if (registration?.type != 3) {
                        screenAction == 'sua'
                          ? handleUpdateRegistration()
                          : handleCreateRegistration()
                      } else changeModalProperty('confirm', true)
                    }}
                  >
                    <i className="fa-regular fa-check"></i>Lưu
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </PrivateBaseLayout>

      <ModalConnectConfig
        title={'Nhập thông tin chữ ký số HSM'}
        method={'HSM'}
        requirePassCode={false}
        open={!!showModal.connectConfig}
        onOpenChange={(state) => changeModalProperty('connectConfig', state)}
        onApply={handleAddDigitalCertificateHSM}
      />

      <Modal
        open={isInvoiceTypeGuideOpen}
        onCancel={() => setIsInvoiceTypeGuideOpen(false)}
        title="Hình thức hóa đơn"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsInvoiceTypeGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <p style={{ marginBottom: 16, color: '#343a40' }}>
          Chọn đầy đủ các hình thức hóa đơn mà đơn vị sử dụng theo quy định tại
          Điều 91 của{' '}
          <span style={{ color: '#3478f6' }}>
            Luật Quản lý thuế 38/2019/QH14
          </span>
          ; khoản 9 Điều 8; Điều 12 và Điều 13,{' '}
          <span style={{ color: '#3478f6' }}>Nghị định số 254/2026/NĐ-CP</span>.
        </p>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
          }}
        >
          <span style={{ fontStyle: 'italic', color: '#343a40' }}>
            <strong>Lưu ý:</strong> Nếu sử dụng nhiều phần mềm phát hành hóa đơn
            điện tử của các tổ chức giải pháp khác nhau, đơn vị cần chọn đầy đủ
            các hình thức hóa đơn sử dụng trên tất cả các phần mềm này.
          </span>
        </div>
      </Modal>

      <Modal
        open={isDataTransferGuideOpen}
        onCancel={() => setIsDataTransferGuideOpen(false)}
        title="Hình thức gửi dữ liệu hóa đơn điện tử"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsDataTransferGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <ul
          style={{
            paddingLeft: 20,
            marginBottom: 0,
            color: '#343a40',
          }}
        >
          <li style={{ marginBottom: 12 }}>
            Chọn mục a nếu đơn vị thuộc trường hợp sử dụng hóa đơn điện tử có mã
            không phải trả tiền dịch vụ theo khoản 1 và khoản 2 Điều 11 của{' '}
            <span style={{ color: '#3478f6' }}>Nghị định 254/2026/NĐ-CP</span>.
          </li>
          <li>
            Mục b sẽ được chương trình tự động tích chọn nếu đơn vị có sử dụng
            hình thức hóa đơn điện tử không có mã của cơ quan thuế.
          </li>
        </ul>
      </Modal>

      <Modal
        open={isTransferMethodGuideOpen}
        onCancel={() => setIsTransferMethodGuideOpen(false)}
        title="Phương thức chuyển dữ liệu hóa đơn điện tử"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsTransferMethodGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <ul
          style={{
            paddingLeft: 20,
            marginBottom: 0,
            color: '#343a40',
          }}
        >
          <li style={{ marginBottom: 12 }}>
            Chọn “Chuyển đầy đủ nội dung từng hóa đơn” đối với hóa đơn điện tử
            có mã của CQT, hóa đơn điện tử có mã của CQT khởi tạo từ máy tính
            tiền và hóa đơn điện tử không có mã của CQT thuộc các trường hợp quy
            định tại điểm a.3, khoản 3, Điều 16 của{' '}
            <span style={{ color: '#3478f6' }}>Nghị định 254/2026/NĐ-CP</span>.
          </li>
          <li>
            Chọn “Chuyển dữ liệu hóa đơn điện tử theo Bảng tổng hợp dữ liệu hóa
            đơn điện tử” đối với hóa đơn điện tử không có mã của CQT thuộc các
            trường hợp được quy định tại điểm a.1, khoản 3, Điều 16,{' '}
            <span style={{ color: '#3478f6' }}>Nghị định 254/2026/NĐ-CP</span>.
          </li>
        </ul>
      </Modal>

      <Modal
        open={isInvoiceTypeListGuideOpen}
        onCancel={() => setIsInvoiceTypeListGuideOpen(false)}
        title="Loại hóa đơn sử dụng"
        width={600}
        footer={
          <Button
            type="primary"
            onClick={() => setIsInvoiceTypeListGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <ul
          style={{
            paddingLeft: 20,
            marginBottom: 16,
            color: '#343a40',
          }}
        >
          <li style={{ marginBottom: 8 }}>
            Chọn “Hóa đơn GTGT” nếu đơn vị kê khai, tính thuế GTGT theo phương
            pháp khấu trừ.
          </li>
          <li style={{ marginBottom: 8 }}>
            Chọn “Hóa đơn bán hàng” nếu đơn vị kê khai, tính thuế GTGT theo
            phương pháp trực tiếp trên giá trị gia tăng.
          </li>
          <li style={{ marginBottom: 8 }}>
            Chọn “Hóa đơn thương mại” nếu đơn vị có hoạt động xuất khẩu hàng
            hóa, cung cấp dịch vụ ra nước ngoài đáp ứng điều kiện chuyển dữ liệu
            hóa đơn thương mại bằng phương thức điện tử đến CQT.
          </li>
          <li style={{ marginBottom: 8 }}>
            Chọn “Hóa đơn bán tài sản công” nếu đơn vị phát sinh hoạt động bán,
            chuyển nhượng các tài sản công thực hiện theo quy định của pháp luật
            về quản lý, sử dụng tài sản công.
          </li>
          <li style={{ marginBottom: 8 }}>
            Chọn “Hóa đơn bán hàng dự trữ quốc gia” nếu đơn vị có phát sinh hoạt
            động bán hàng dự trữ quốc gia theo quy định của pháp luật.
          </li>
          <li style={{ marginBottom: 8 }}>
            Chọn “Các loại hóa đơn khác” nếu đơn vị sử dụng vé điện tử, vé điện
            tử khởi tạo từ máy tính tiền.
          </li>
          <li>
            Chọn “Các chứng từ được in, phát hành, sử dụng và quản lý như hóa
            đơn” nếu đơn vị sử dụng phiếu xuất kho kiêm vận chuyển nội bộ, phiếu
            xuất kho hàng gửi bán đại lý.
          </li>
        </ul>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
          }}
        >
          <InfoCircleOutlined
            style={{ color: '#3478f6', marginTop: 3, flexShrink: 0 }}
          />
          <span style={{ fontStyle: 'italic', color: '#343a40' }}>
            <strong>Lưu ý:</strong> Nếu sử dụng nhiều phần mềm phát hành hóa đơn
            điện tử của các tổ chức giải pháp khác nhau, đơn vị cần chọn đầy đủ
            các loại hóa đơn sử dụng trên tất cả các phần mềm này.
          </span>
        </div>
      </Modal>

      <Modal
        open={isServiceProviderGuideOpen}
        onCancel={() => setIsServiceProviderGuideOpen(false)}
        title="Tổ chức cung cấp dịch vụ"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsServiceProviderGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <p style={{ marginBottom: 8, color: '#343a40' }}>
          Khai báo thông tin của tổ chức cung cấp dịch vụ hóa đơn điện tử cho
          đơn vị.
        </p>
        <div
          style={{
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
            color: '#343a40',
            fontStyle: 'italic',
          }}
        >
          <strong>Lưu ý:</strong>
          <ul style={{ paddingLeft: 20, margin: '4px 0 0' }}>
            <li style={{ marginBottom: 8 }}>
              Nếu sử dụng nhiều phần mềm phát hành hóa đơn điện tử khác nhau,
              đơn vị cần khai báo đầy đủ thông tin của các tổ chức cung cấp dịch
              vụ hóa đơn điện tử.
            </li>
            <li>
              <strong>Thời gian sử dụng dịch vụ:</strong>
              <div>
                <strong>Từ ngày:</strong> (Ngày bắt đầu sử dụng dịch vụ - bắt
                buộc nhập)
              </div>
              <div style={{ paddingLeft: 16 }}>
                - Từ ngày phải &lt;= Ngày hiện tại.
              </div>
              <div>
                <strong>Đến ngày:</strong> (Ngày kết thúc sử dụng dịch vụ - có
                thể để trống)
              </div>
            </li>
          </ul>
        </div>
      </Modal>

      <Modal
        open={isEInvoiceConnectorGuideOpen}
        onCancel={() => setIsEInvoiceConnectorGuideOpen(false)}
        title="Thông tin đơn vị truyền nhận"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsEInvoiceConnectorGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <p style={{ marginBottom: 8, color: '#343a40' }}>
          Khai báo thông tin tổ chức truyền nhận dữ liệu hóa đơn điện tử của đơn
          vị đến hệ thống hóa đơn điện tử của Cục Thuế.
        </p>
        <div
          style={{
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
            color: '#343a40',
            fontStyle: 'italic',
          }}
        >
          <strong>Lưu ý:</strong>
          <ul style={{ paddingLeft: 20, margin: '4px 0 0' }}>
            <li style={{ marginBottom: 8 }}>
              Nếu sử dụng nhiều phần mềm phát hành hóa đơn điện tử khác nhau,
              đơn vị cần khai báo đầy đủ thông tin của các tổ chức truyền nhận
              dữ liệu hóa đơn điện tử.
            </li>
            <li style={{ marginBottom: 8 }}>
              <strong>Thời gian sử dụng dịch vụ truyền nhận:</strong>
              <div>
                <strong>Từ ngày:</strong> (Ngày bắt đầu sử dụng dịch vụ - bắt
                buộc nhập)
              </div>
              <div style={{ paddingLeft: 16 }}>
                - Ngày bắt đầu &gt;= Ngày bắt đầu cung cấp dịch vụ của tổ chức
                truyền nhận được Cục Thuế công bố.
              </div>
              <div style={{ paddingLeft: 16 }}>
                - Từ ngày phải &lt;= Ngày hiện tại.
              </div>
              <div>
                <strong>Đến ngày:</strong> (Ngày kết thúc sử dụng dịch vụ - có
                thể để trống)
              </div>
            </li>
            <li style={{ marginBottom: 0 }}>
              Xem thông tin các tổ chức truyền nhận được Cục Thuế công bố{' '}
              <a
                href="https://hoadondientu.gdt.gov.vn/danh-sach-tvan"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#3478f6', fontWeight: 700 }}
              >
                TẠI ĐÂY
              </a>
              .
            </li>
          </ul>
        </div>
      </Modal>

      <Modal
        open={isDependentUnitsGuideOpen}
        onCancel={() => setIsDependentUnitsGuideOpen(false)}
        title="Thông tin đơn vị hạch toán phụ thuộc cần cấp quyền tra cứu hóa đơn"
        width={420}
        footer={
          <Button
            type="primary"
            onClick={() => setIsDependentUnitsGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <p style={{ marginBottom: 8, color: '#343a40' }}>
          Khai báo thông tin của các chi nhánh, đơn vị phụ thuộc mà công ty mẹ
          cần khai thác dữ liệu hóa đơn điện tử.
        </p>
        <div
          style={{
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
            color: '#343a40',
            fontStyle: 'italic',
          }}
        >
          <strong>Lưu ý:</strong>
          <ul style={{ paddingLeft: 20, margin: '4px 0 0' }}>
            <li style={{ marginBottom: 8 }}>
              Nếu có nhiều chi nhánh, đơn vị phụ thuộc cần khai thác dữ liệu,
              đơn vị cần khai báo đầy đủ thông tin của các chi nhánh, đơn vị phụ
              thuộc này.
            </li>
            <li>
              <strong>Thời gian cấp quyền tra cứu hóa đơn:</strong>
              <div>
                - <strong>Từ ngày:</strong> Ngày bắt đầu cấp quyền tra cứu hóa
                đơn (bắt buộc nhập)
              </div>
              <div>
                - <strong>Đến ngày:</strong> Ngày kết thúc cấp quyền tra cứu hóa
                đơn (có thể bỏ trống)
              </div>
            </li>
          </ul>
        </div>
      </Modal>

      <Modal
        open={isEInvoiceSuspendGuideOpen}
        onCancel={() => setIsEInvoiceSuspendGuideOpen(false)}
        title="Đề nghị tạm ngừng sử dụng hóa đơn điện tử"
        width={600}
        footer={
          <Button
            type="primary"
            onClick={() => setIsEInvoiceSuspendGuideOpen(false)}
          >
            Đóng
          </Button>
        }
      >
        <p style={{ marginBottom: 8, color: '#343a40' }}>
          <strong>
            Khai báo các thông tin đăng ký tạm ngừng sử dụng hóa đơn điện tử
            khi:
          </strong>
          <br />
          Doanh nghiệp, tổ chức kinh tế, tổ chức khác, hộ kinh doanh, cá nhân
          kinh doanh tạm ngừng kinh doanh.
        </p>
        <div
          style={{
            padding: 12,
            borderRadius: 4,
            backgroundColor: '#e8f3ff',
            color: '#343a40',
            fontStyle: 'italic',
          }}
        >
          <strong>Lưu ý:</strong>
          <ul style={{ paddingLeft: 20, margin: '4px 0 0' }}>
            <li style={{ marginBottom: 8 }}>
              Khai báo thời gian ngừng sử dụng HĐĐT theo tổ chức cung cấp dịch
              vụ và số sê-ri chứng thư số (nếu có):
              <div>
                - <strong>Từ ngày:</strong> Ngày bắt đầu ngừng sử dụng (bắt buộc
                nhập)
              </div>
              <div>
                - <strong>Đến ngày:</strong> Ngày kết thúc ngừng sử dụng (bắt
                buộc nhập)
              </div>
            </li>
            <li style={{ marginBottom: 8 }}>
              Nếu sử dụng nhiều phần mềm phát hành hóa đơn điện tử khác nhau,
              đơn vị cần khai báo đầy đủ thông tin của các tổ chức cung cấp dịch
              vụ và chứng thư số sử dụng.
            </li>
            <li>
              Chỉ khai báo số sê-ri chứng thư số nếu đơn vị cần đăng ký tạm
              ngừng sử dụng cho 1 hoặc nhiều chứng thư số cụ thể. Trường hợp
              đăng ký ngừng sử dụng cho toàn bộ chứng thư số thì có thể để trống
              thông tin này.
            </li>
          </ul>
        </div>
      </Modal>

      <ModalSignatureInfo
        open={!!showModal.signatureInfo}
        onOpenChange={(state) => changeModalProperty('signatureInfo', state)}
        onApply={handleAddDigitalCertificateMannual}
      />

      <ModalChooseSignMethod
        show={!!showModal.chooseSignMethod}
        setShow={(state) => changeModalProperty('chooseSignMethod', state)}
        header={'Chọn phương thức thêm chứng thư số'}
        content={'Vui lòng chọn phương thức thêm chứng thư số'}
        handleChooseUSBToken={() => {
          changeModalProperty('chooseSignMethod', false)
          handlePressedAddDigitalCertificate()
        }}
        handleChooseHSM={() => {
          changeModalProperty('chooseSignMethod', false)
          changeModalProperty('connectConfig', true)
        }}
        handleChooseManually={() => {
          changeModalProperty('signatureInfo', true)
          changeModalProperty('chooseSignMethod', false)
        }}
      />

      <ModalWarning
        show={!!showModal.confirm}
        setShow={(state) => changeModalProperty('confirm', state)}
        header="Xác nhận"
        content="Vui lòng đảm bảo thông tin cập nhật là chính xác trước khi lưu. Việc nhập sai thông tin từ hệ thống cũ (bao gồm cả mã CQT và số thứ tự bắt đầu) có thể dẫn đến sai sót trong việc phát hành hóa đơn."
        handleConfirm={() => {
          changeRegistrationProperty('locationName', '')

          screenAction == 'sua'
            ? handleUpdateRegistration()
            : handleCreateRegistration()
        }}
      />
      <ModalWarning
        show={!!showModal.warning.visible}
        setShow={(state) =>
          changeModalProperty('warning', {
            visible: state,
            message: '',
          })
        }
        header="Thông báo"
        content={showModal.warning.message}
      />
    </div>
  )
}

export default CreateRegistration
